export default __webpack_public_path__ + "858085a9027d84bd9e2e1d50dcc6d692.svg";